module.exports = __webpack_public_path__ + "img/waterspots_overlay.9887e678.jpeg";